import { useEffect } from 'react';

import { useAuth } from 'context/auth';
import { handOffTokenToExtension, isExtensionReachable } from 'services/extensionAuth';
import { probePortalExtension } from 'services/portalExtension';

import { EXTENSION_AUTH_MESSAGES } from './inboundReferrals/constants';

// Headless. Hands the browser extension a token when signed in and the extension is
// installed, and again whenever the extension requests one (its renewal path).
export default function ExtensionAuthManager() {
  const { token } = useAuth();

  useEffect(() => {
    // Nothing to do where the extension can't be reached (other browsers, not installed,
    // jsdom) — skip both the probe and the listener.
    if (!token || !isExtensionReachable()) return;

    probePortalExtension().then((installed) => {
      if (installed) handOffTokenToExtension().catch(() => {});
    });

    const onMessage = (event: MessageEvent<{ type?: string }>) => {
      if (event.source !== window) return;
      if (event.data?.type !== EXTENSION_AUTH_MESSAGES.handoffRequest) return;
      handOffTokenToExtension().catch(() => {});
    };

    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [token]);

  return null;
}
